 <template>
  <section class="align" id="scrollMarker">
<!--    <div class="layoutBorder">-->
<!--      <div class="layoutHeader">-->
<!--        <h4>Технические работы</h4>-->
<!--      </div>-->
<!--      <div class="layoutBody">-->
<!--        В течение некоторого времени сервис будет недоступен.-->
<!--      </div>-->
<!--    </div>-->
    <div v-if="formView" >
      <div class="selector">
        <rangeTopLine></rangeTopLine>
        <range></range>
        <rangeBottomLine></rangeBottomLine>
      </div>
      <div class="selector">
        <p>Еженедельный платеж составит:</p>
        <p>{{FixedPay | moneyFormat}}</p>
      </div>

      <div class="checkGroup">
        <div class="indicatorWrap">
          <div class="indicatorWrapIco" v-bind:class="geoResultClass">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'falseSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.412 12.251l-4.47-4.47 4.147-4.149a2.007 2.007 0 10-2.838-2.84L8.1 4.941 3.75.589a2.008 2.008 0 10-2.84 2.84L5.262 7.78.588 12.454a2.008 2.008 0 102.84 2.84l4.674-4.674 4.47 4.47a2.007 2.007 0 102.84-2.839z" fill="#fff"/></svg>
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'trueSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.148 13.098a2.09 2.09 0 01-2.956 0l-4.58-4.58a2.09 2.09 0 112.956-2.956L6.297 8.29a.53.53 0 00.747 0L14.432.902a2.09 2.09 0 012.956 2.955l-9.24 9.24z" fill="#fff"/></svg>
          </div>
          <div v-if="checkGeo.result == 0">
            <button v-if="!checkGeo.loading" v-on:click="checkGeoRequest">Проверить</button>
            <div v-else class="chekStatus">Идет проверка</div>
          </div>
          <div v-if="checkGeo.result > 0" class="resultMsg rTrue">Адрес в зоне</div>
          <div v-if="checkGeo.result < 0" class="resultMsg rFalse">Адрес не в зоне</div>
        </div>
        <div class="requestFieldWrap">
          <fmSelectDadata :refs="'RESIDENTIAL_ADDRESS'"></fmSelectDadata>
        </div>
      </div>
      <div class="checkGroup">
        <div class="indicatorWrap">
          <div class="indicatorWrapIco" v-bind:class="repeatResultClass">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'falseSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.412 12.251l-4.47-4.47 4.147-4.149a2.007 2.007 0 10-2.838-2.84L8.1 4.941 3.75.589a2.008 2.008 0 10-2.84 2.84L5.262 7.78.588 12.454a2.008 2.008 0 102.84 2.84l4.674-4.674 4.47 4.47a2.007 2.007 0 102.84-2.839z" fill="#fff"/></svg>
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'trueSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.148 13.098a2.09 2.09 0 01-2.956 0l-4.58-4.58a2.09 2.09 0 112.956-2.956L6.297 8.29a.53.53 0 00.747 0L14.432.902a2.09 2.09 0 012.956 2.955l-9.24 9.24z" fill="#fff"/></svg>
          </div>
          <div v-if="checkRepeat.result < 0">
            <button v-if="!checkRepeat.loading" v-on:click="checkRepeatRequest">Проверить</button>
            <div v-else class="chekStatus">Идет проверка</div>
          </div>
          <div v-if="checkRepeat.result == 0" class="resultMsg rTrue">Проверка пройдена</div>
          <div v-if="checkRepeat.result > 0" class="resultMsg rFalse">Проверка не пройдена</div>
        </div>
        <div class="requestFieldWrap">
          <div class="inputsCollection">
            <div class="inputs2">
              <fmInput
                :refs="'LAST_NAME'"
              ></fmInput>
            </div>
            <div class="inputs2">
              <fmInput
                :refs="'FIRST_NAME'"
              ></fmInput>
            </div>
          </div>
          <div class="inputsCollection">
            <div class="inputs2">
              <fmInput
                :refs="'SECOND_NAME'"
              ></fmInput>
            </div>
            <div class="inputs2">
              <fmInput
                :refs="'PHONE'"
              ></fmInput>
            </div>
          </div>
          <fmRadio :refs="'GENDER'"></fmRadio>
        </div>

      </div>
      <div class="checkGroup">
        <div class="indicatorWrap">
          <div class="indicatorWrapIco" v-bind:class="repeatPassportResultClass">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'falseSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.412 12.251l-4.47-4.47 4.147-4.149a2.007 2.007 0 10-2.838-2.84L8.1 4.941 3.75.589a2.008 2.008 0 10-2.84 2.84L5.262 7.78.588 12.454a2.008 2.008 0 102.84 2.84l4.674-4.674 4.47 4.47a2.007 2.007 0 102.84-2.839z" fill="#fff"/></svg>
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'trueSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.148 13.098a2.09 2.09 0 01-2.956 0l-4.58-4.58a2.09 2.09 0 112.956-2.956L6.297 8.29a.53.53 0 00.747 0L14.432.902a2.09 2.09 0 012.956 2.955l-9.24 9.24z" fill="#fff"/></svg>
          </div>
          <div v-if="checkRepeatPassport.result < 0">
            <button v-if="!checkRepeatPassport.loading" v-on:click="checkRepeatPassportRequest">Проверить</button>
            <div v-else class="chekStatus">Идет проверка</div>
          </div>
          <div v-if="checkRepeatPassport.result == 0" class="resultMsg rTrue">Проверка пройдена</div>
          <div v-if="checkRepeatPassport.result > 0" class="resultMsg rFalse">Проверка не пройдена</div>
        </div>
        <div class="requestFieldWrap">
          <div class="inputsCollection">
            <div class="inputs4">
              <fmInput
                :refs="'PASSPORT_SERIES'"
              ></fmInput>
            </div>
            <div class="inputs4">
              <fmInput
                :refs="'PASSPORT_NUMBER'"
              ></fmInput>
            </div>
            <div class="inputs4">
              <fmInput
                :refs="'BIRTHDAY'"
              ></fmInput>
            </div>
            <div class="inputs4">
              <fmInput :refs="'PASSPORT_DATE'"></fmInput>
            </div>
          </div>
          <div class="inputsCollection">
            <div class="inputs4">
              <fmInput :refs="'PASSPORT_DEP_CODE'"></fmInput>
            </div>
            <div class="inputs3_4">
              <fmSelectDadata :refs="'PASSPORT_DEP'"></fmSelectDadata>
            </div>
          </div>
          <div class="">
            <div id="adressCoincides">
              <fmCheckBox :name="'IS_ADDRESS_COINCIDES'"
                          :true-value="'Y'"
                          :false-value="'N'"
              ></fmCheckBox>
            </div>
            <fmSelectDadata :refs="'REGISTRATION_ADDRESS'"></fmSelectDadata>
          </div>
        </div>
      </div>
      <div class="otherInput" v-if="canShowOtherField">
        <h4>Контактная информация</h4>
        <div class="inputsCollection" v-if="cookie == 100006">
          <div class="inputs4">
            <fmSelectDadata :refs="'WORK_JOB'"></fmSelectDadata>
          </div>
          <div class="inputs4">
<!--            <fmSelectDadata :refs="'WORK_TITLE'"></fmSelectDadata>-->
          </div>
          <div class="inputs4">
            <fmSelect :refs="'EXPER_RADIO'"></fmSelect>
          </div>
          <div class="inputs4">
            <fmInput :refs="'CONST_INCOME'"></fmInput>
          </div>
        </div>

        <div class="inputsCollection" v-if="cookie != 100006">
          <div class="inputs4">
            <fmInput :refs="'EMAIL'"></fmInput>
          </div>
          <div class="inputs4">
            <fmSelectDadata :refs="'WORK_JOB'"></fmSelectDadata>
          </div>
          <div class="inputs4">
            <fmSelectDadata :refs="'WORK_TITLE'"></fmSelectDadata>
          </div>
          <div class="inputs4">
            <fmSelect :refs="'EXPER_RADIO'"></fmSelect>
          </div>

        </div>
        <div class="inputsCollection" v-if="cookie != 100006">
          <div class="inputs4" >
            <fmSelect :refs="'CREDHISTORY_RADIO'"></fmSelect>
          </div>
          <div class="inputs4">
            <fmInput :refs="'CONST_INCOME'"></fmInput>
          </div>
          <div class="inputs4">
            <fmInput :refs="'OTHER_SOURCES_OF_INCOME'"></fmInput>
          </div>
          <div class="inputs4">
          </div>
        </div>
        <div class="inputsCollection" v-if="cookie != 100006">
          <div class="inputs4">
            <fmInput :refs="'MEETING_DATE'"></fmInput>
          </div>
          <div class="inputs4">
            <fmInput :refs="'MEETING_HOUR'"></fmInput>
          </div>
          <div class="inputs4">
          </div>
          <div class="inputs4">
          </div>
        </div>
        <div id="submitWrap">
          <button v-on:click="saveRequest">Сохранить заявку</button>
        </div>
      </div>
    </div>
    <div v-else>
      <h4>Заяка успешно сохранена</h4>
    </div>

  </section>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import "@/assets/css/oldAppCss.css";
  export default {
    name: "cc",
    data() {
      return {
        checkGeo: {
          result: 0,
          loading: false,
          adressLastCheck: '',
        },
        checkRepeat: {
          result: -1,
          loading: false,
          fieldLastCheck: {
            'SECOND_NAME': '',
            'LAST_NAME': '',
            'FIRST_NAME': '',
            'PHONE': '',
          }
        },
        checkRepeatPassport: {
          result: -1,
          loading: false,
          fieldLastCheck: {
            'FIRST_NAME': '',
            'LAST_NAME': '',
            'SECOND_NAME': '',
            'PASSPORT_SERIES': '',
            'PASSPORT_NUMBER': '',
            'BIRTHDAY': '',
            'REGISTRATION_ADDRESS': '',
          },
        },
        formView:true,
        isSending: false,
      }
    },
    components: {
      fmSelectDadata: () => import('@/components/form/fmSelectDadata'),
      // formSelectDadata: () => import('@/views/pdlloan/formSelectDadata'),
      fmInput: () => import('@/components/form/fmInput'),
      fmCheckBox: () => import('@/components/form/fmCheckBox'),
      fmRadio:()=>import('@/components/form/fmRadio'),
      // fmSelectDadataPassport: () => import('@/components/form/fmSelectDadataPassport'),
      fmSelect: () => import('@/components/form/fmSelect'),
      range: () => import('@/components/chunk/range'),
      rangeTopLine: () => import('@/components/chunk/rangeTopLine'),
      rangeBottomLine: () => import('@/components/chunk/rangeBottomLine'),
    },
    computed: {
      ...mapState({
        valueVuex: state => state.Form.sendData,
        statusVuex: state => state.Form.workData,
		cookie: state => state.Cookie.cookie.Partner_Id,
      }),
      ...mapGetters([
        'isAdressValid',
        'fieldForCheckDublicateLead',
        'fieldForCheckPassportDublicateLead',
        'FixedPay',
      ]),
      geoResultClass() {
        return {
          trueColor: this.checkGeo.result > 0,
          falseColor: this.checkGeo.result < 0,
          defColor: this.checkGeo.result == 0
        }
      },
      repeatResultClass() {
        return {
          trueColor: this.checkRepeat.result == 0,
          falseColor: this.checkRepeat.result > 0,
          defColor: this.checkRepeat.result < 0
        }
      },
      repeatPassportResultClass() {
        return {
          trueColor: this.checkRepeatPassport.result == 0,
          falseColor: this.checkRepeatPassport.result > 0,
          defColor: this.checkRepeatPassport.result < 0
        }
      },
      canShowOtherField(){
        return this.checkGeo.result > 0 && this.checkRepeat.result == 0 && this.checkRepeatPassport.result == 0;
        // return true
      }
    },
    methods: {
      checkGeoRequest() {
        this.checkGeo.loading = true;
        let checkAdress = this.isAdressValid('RESIDENTIAL_ADDRESS');
        //отсекаем если адрес не полный
        if (checkAdress.length > 0) {
          this.$store.dispatch('fieldError', {
            target: 'RESIDENTIAL_ADDRESS',
            value: checkAdress
          });
          this.checkGeo.loading = false;
          return false;
        }
        //начинаем проверку
        this.checkGeo.adressLastCheck = this.valueVuex.RESIDENTIAL_ADDRESS;
        this.$myApi.SendRequest({
          action: 'GetAddressTerritory',
          Address: this.valueVuex.RESIDENTIAL_ADDRESS,
          RESIDENTIAL_ADDRESS_DADATA:this.valueVuex.RESIDENTIAL_ADDRESS_DADATA,
        }).then(() => {
          this.checkGeo.result = 1;
        }).catch((res) => {
          let ErrorResult = this.$myApi.parseError(res, 'fio adressCheck');
          if (ErrorResult.ExecutionErrorCode > 0) {
            this.checkGeo.result = (-1) * ErrorResult.ExecutionErrorCode;
          }
        }).finally(() => {
          this.checkGeo.loading = false;
          this.$myApi.singleRequest({action: 'adressZoneLog', value: this.checkGeo.result});
        });
      },
      checkRepeatRequest() {
        //проверяем готовность полей к проверке
        this.checkRepeat.loading = true;
        let checkField = [
          'SECOND_NAME',
          'LAST_NAME',
          'FIRST_NAME',
          'PHONE'
        ];
        let errCount = 0;
        checkField.forEach(item => {
          if (this.statusVuex[item].code != 0) {
            this.$store.dispatch('errorShow', {
              target: item,
              value: true,
            });
            errCount += 1;
          }
        });
        if (errCount != 0) {
          this.checkRepeat.loading = false;
          return false;
        }

        //топорно запускаем сохраннение данных, нужно от редактирования данных во время заполнения формы
        //так уебански, что бы не встрять на возможной разной сортировке объекта при сравнении
        this.checkRepeat.fieldLastCheck.FIRST_NAME = this.valueVuex.FIRST_NAME;
        this.checkRepeat.fieldLastCheck.LAST_NAME = this.valueVuex.LAST_NAME;
        this.checkRepeat.fieldLastCheck.SECOND_NAME = this.valueVuex.SECOND_NAME;
        this.checkRepeat.fieldLastCheck.PHONE = this.valueVuex.PHONE;
        //запускаем проверку
        this.$myApi.SendRequest({
          action: 'isIssetActiveRequest',
          data: {
            FIRST_NAME: this.valueVuex.FIRST_NAME,
            LAST_NAME: this.valueVuex.LAST_NAME,
            SECOND_NAME: this.valueVuex.SECOND_NAME,
            PHONE: this.valueVuex.PHONE
          },
        }).then(() => {
          this.checkRepeat.result = 0;
        }).catch((res) => {
          let ErrorResult = this.$myApi.parseError(res, 'fio isIssetActiveRequest');
          if (ErrorResult.ExecutionErrorCode > 0) {
            this.$myApi.singleRequest({
              action: 'checkLog',
              value: res.Response.ExecutionError.ExecutionErrorMessage
            });
            this.checkRepeat.result = res.Response.ExecutionError.ExecutionErrorMessage;
          }
        }).finally(() => {
          this.checkRepeat.loading = false;
        })
      },
      checkRepeatPassportRequest() {
        //проверяем готовность полей к проверке
        this.checkRepeatPassport.loading = true;
        let checkField = [
          'FIRST_NAME',
          'LAST_NAME',
          'SECOND_NAME',
          'PASSPORT_SERIES',
          'PASSPORT_NUMBER',
          'BIRTHDAY',
          'REGISTRATION_ADDRESS'
        ];
        let errCount = 0;
        checkField.forEach(item => {
          if (this.statusVuex[item].code != 0) {
            this.$store.dispatch('errorShow', {
              target: item,
              value: true,
            });
            errCount += 1;
          }
        });
        if (errCount != 0) {
          this.checkRepeatPassport.loading = false;
          return false;
        }


        //топорно запускаем сохраннение данных, нужно от редактирования данных во время заполнения формы
        //так уебански, что бы не встрять на возможной разной сортировке объекта при сравнении
        this.checkRepeatPassport.fieldLastCheck.FIRST_NAME = this.valueVuex.FIRST_NAME;
        this.checkRepeatPassport.fieldLastCheck.LAST_NAME = this.valueVuex.LAST_NAME;
        this.checkRepeatPassport.fieldLastCheck.SECOND_NAME = this.valueVuex.SECOND_NAME;
        this.checkRepeatPassport.fieldLastCheck.PASSPORT_SERIES = this.valueVuex.PASSPORT_SERIES;
        this.checkRepeatPassport.fieldLastCheck.PASSPORT_NUMBER = this.valueVuex.PASSPORT_NUMBER;
        this.checkRepeatPassport.fieldLastCheck.BIRTHDAY = this.valueVuex.BIRTHDAY;
        this.checkRepeatPassport.fieldLastCheck.REGISTRATION_ADDRESS = this.valueVuex.REGISTRATION_ADDRESS;
        this.checkRepeatPassport.fieldLastCheck.PHONE = this.valueVuex.PHONE;

        //запускаем проверку

        this.$myApi.SendRequest({
          action: 'chekRegistrationAdress',
          REGISTRATION_ADDRESS_DADATA: this.valueVuex.REGISTRATION_ADDRESS_DADATA,
          FIRST_NAME: this.valueVuex.FIRST_NAME,
          LAST_NAME: this.valueVuex.LAST_NAME,
          SECOND_NAME: this.valueVuex.SECOND_NAME,
          PASSPORT_SERIES: this.valueVuex.PASSPORT_SERIES,
          PASSPORT_NUMBER: this.valueVuex.PASSPORT_NUMBER,
          BIRTHDAY: this.valueVuex.BIRTHDAY,
          PHONE: this.valueVuex.PHONE,
        }).then(() => {
          this.checkRepeatPassport.result = 0;
        }).catch((res) => {
          let ErrorResult = this.$myApi.parseError(res, 'passport chekRegistrationAdress');
          if (ErrorResult.ExecutionErrorCode > 0) {
            this.$myApi.singleRequest({
              action: 'checkLog',
              value: res.Response.ExecutionError.ExecutionErrorMessage
            });
            this.checkRepeatPassport.result = res.Response.ExecutionError.ExecutionErrorMessage;
          }
        }).finally(() => {
          this.checkRepeatPassport.loading = false;
        })
      },
      getMeetingDate() {
        let date = new Date(new Date().getTime() + 1000 * 60 * 60 * 24);
        let day = date.getDate();
        let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        day = day < 10 ? '0' + day : day;
        let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        return {
          MEETING_DATE:date.getFullYear() + '-' + month + '-' + day,
          MEETING_HOUR: h + ':' + m
        };
      },
      checkFormFieldValue(){
        let kostilCheckForm = [
          'AVERAGE_EXPENSES_PER_MONTH',
          'AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS',
          'EDUCATION',
          'MARITAL_STATUS',
          'SOURCE_OF_INCOME',
          'PURPOSE_OF_THE_LOAN',
          'FINANCIAL_POSITION',
          'SmsConfCode',
          'ASP',
          // 'PASSPORT_DEP_CODE',
          // 'PASSPORT_DATE',
          'BIRTHPLACE',
          // 'PASSPORT_DEP',
          'OTHER_SOURCES_OF_INCOME'
        ];
        kostilCheckForm.forEach(item=>{
         this.$store.commit('saveWorkData',{
           target:item,
           status:{
             code:'0',
             msg:''
           }
         });
        });

      let fieldTocheck= [
        'PHONE',
        'RESIDENTIAL_ADDRESS',
        'SECOND_NAME',
        'LAST_NAME',
        'BIRTHDAY',
        'FIRST_NAME',
        'GENDER',
        'PASSPORT_SERIES',
        'PASSPORT_NUMBER',
        'PASSPORT_DEP_CODE',
        'PASSPORT_DATE',
        // 'BIRTHPLACE',
        'REGISTRATION_ADDRESS',
        'RESIDENTIAL_ADDRESS',
        'PASSPORT_DEP',
        'CONST_INCOME',
        // 'OTHER_SOURCES_OF_INCOME',
        'WORK_JOB',
        'EXPER_RADIO',
      ];

        //проверяем заполнения полей
        let isFormFieldCorrect = true;
        fieldTocheck.forEach(item => {
          this.$external.consoleDebug({item});
          if (this.statusVuex[item].code !== 0) {

                this.$store.dispatch('errorShow', {
                  target: item,
                  value: true,
                });

            isFormFieldCorrect = false;
          }
        });
        // for (let key in this.valueVuex) {
        //   if (this.statusVuex[key].code != 0) {
        //     this.$store.dispatch('errorShow', {
        //       target: key,
        //       value: true,
        //     });
        //     isFormFieldCorrect = false;
        //   }
        // }
        let checkAdress = this.isAdressValid('RESIDENTIAL_ADDRESS');
        if (checkAdress.length > 0) {
          this.$store.dispatch('fieldError',{
            target: 'RESIDENTIAL_ADDRESS',
            value: checkAdress
          });
          isFormFieldCorrect =  false;
        }

         checkAdress = this.isAdressValid('REGISTRATION_ADDRESS');
        if (checkAdress.length > 0) {
          this.$store.dispatch('fieldError',{
            target: 'REGISTRATION_ADDRESS',
            value: checkAdress
          });
          isFormFieldCorrect =  false;
        }


       return isFormFieldCorrect;
       },
      saveRequest(){
        if (this.isSending) return;
        if (this.checkFormFieldValue()) {
          this.isSending = true;
          this.$myApi.singleRequest({
            action:'SendRequest',
            data:Object.assign({}, this.valueVuex)
          }).then((res) => {
            if (window.ym) {
              // eslint-disable-next-line no-undef
              ym(51632228, 'reachGoal', 'ccRequest');
            }
            console.log(res);
            this.formView = false;
            try{
              // eslint-disable-next-line no-undef
              VK.Goal('lead');
            } catch (e) {
              console.log(e);
            }
          }).catch((res) => {
            console.log(res);
            alert('Извините произошла ошибка, попробуйте позже.');
            alert(JSON.stringify(res));
          }).finally(() => {
            this.isSending = false;
          });
        } else {
          const errorLabelArr = document.getElementsByClassName('errorMsg');
          if(errorLabelArr.length > 0) {
            errorLabelArr[0].scrollIntoView({behavior: 'smooth',block: 'start'});
            window.scrollBy({ top: -200, left: 0 });
          } else {
            document.getElementById('scrollMarker').scrollIntoView({behavior: 'smooth'});
            window.scrollBy({ top: -200, left: 0 });
          }
        }
      }
    },
    watch: {
      'valueVuex.RESIDENTIAL_ADDRESS'(val) {
        if (this.checkGeo.result != 0 && val != this.checkGeo.adressLastCheck) {
          this.checkGeo.result = 0;
        }
      },
      fieldForCheckDublicateLead(val) {
        if (
          this.checkRepeat.fieldLastCheck.FIRST_NAME != val.FIRST_NAME ||
          this.checkRepeat.fieldLastCheck.LAST_NAME != val.LAST_NAME ||
          this.checkRepeat.fieldLastCheck.SECOND_NAME != val.SECOND_NAME ||
          this.checkRepeat.fieldLastCheck.PHONE != val.PHONE) {
          this.checkRepeat.result = -1;
        }
      },
      fieldForCheckPassportDublicateLead(val) {
        if (
          this.checkRepeatPassport.fieldLastCheck.FIRST_NAME != val.FIRST_NAME ||
          this.checkRepeatPassport.fieldLastCheck.LAST_NAME != val.LAST_NAME ||
          this.checkRepeatPassport.fieldLastCheck.SECOND_NAME != val.SECOND_NAME ||
          this.checkRepeatPassport.fieldLastCheck.PASSPORT_SERIES != val.PASSPORT_SERIES ||
          this.checkRepeatPassport.fieldLastCheck.PASSPORT_NUMBER != val.PASSPORT_NUMBER ||
          this.checkRepeatPassport.fieldLastCheck.BIRTHDAY != val.BIRTHDAY ||
          this.checkRepeatPassport.fieldLastCheck.REGISTRATION_ADDRESS != val.REGISTRATION_ADDRESS
        ) {
          this.checkRepeatPassport.result = -1;
        }
      },
    },
    mounted() {
      if (window.ym) {
        // eslint-disable-next-line no-undef
        ym(51632228,'reachGoal','ccEnter');

      }

      let idArr = {
        partnerID: window.partner_id !== undefined ? window.partner_id : 0,
        sessionId: window.session_id !== undefined ? window.session_id : 0,
      }

      console.log(idArr)
      try {
        this.$store.dispatch('getDealInfo',{phpFileName: 'getDealBaseIndividual',data: idArr} );
      } catch (e) {
        //alert('mounted' + JSON.stringify(e))
      }





      let MeetingDate = this.getMeetingDate();

      this.$store.dispatch('saveSendData',{
        target:'MEETING_DATE',
        value: MeetingDate.MEETING_DATE
      });

      this.$store.dispatch('saveSendData',{
        target:'MEETING_HOUR',
        value: MeetingDate.MEETING_HOUR
      });
      //window.document.cookie='_ym_d=1658312664; _ym_uid=1646827636576170722; _ga=GA1.2.812141792.1658312667; GUID=%7B7BBCBFAE-CC24-94A5-FE32-AB136D7CAB13%7D; _ym_isad=1; _gid=GA1.2.1016393041.1662367434; _ym_visorc=w; Partner_Id=100006; sessionId=4054561; session_id=4054561; _gat_UA-154728161-1=1'
      this.$store.dispatch('readCookie');
      /*console.log('b--')
      console.log(window.partner_id)
      console.log('a--')
      console.log(this.cookie)*/
    }
  }
</script>

<style scoped>
  .selector{border-bottom: 1px solid #0a4d3a;margin-bottom: 10px;padding-bottom: 10px;}
  .checkGroup {display: flex;align-items: flex-start;justify-content: space-between;border-bottom: 1px solid #0a4d3a;margin-bottom: 10px;padding-bottom: 10px;}
  .indicatorWrap {width: 200px;text-align: center}
  .indicatorWrapIco {position: relative;width: 30px;height: 30px;margin: 20px auto;border-radius: 30px;}
  .indicatorWrapIco.defColor {background: #f29900}
  .indicatorWrapIco.trueColor {background: green}
  .indicatorWrapIco.falseColor {background: red}
  .indicatorWrapIco svg {position: absolute;top: calc(50% - 10px);left: calc(50% - 10px);width: 20px;height: 20px;opacity: 0;}
  .indicatorWrapIco.trueColor .trueSvg {opacity: 1;}
  .indicatorWrapIco.falseColor .falseSvg {opacity: 1;}
  .resultMsg {}
  .resultMsg.rTrue {color: green}
  .resultMsg.rFalse {color: red;}
  .chekStatus {}
  .requestFieldWrap {width: calc(100% - 210px)}
  /deep/ .errorMsg {color: red;}
  .inputsCollection {display: flex;align-items: flex-start;justify-content: space-between}
  .inputsCollection .inputs2 {width: calc(50% - 4px);}
  .inputsCollection .inputs1 {width: 444px;}
  .inputsCollection .inputs3 {width: calc(33% - 4px);}
  .inputsCollection .inputs4 {width: calc(25% - 4px);}
  .inputsCollection .inputs3_4 {width: calc(75% - 4px);}
  #adressCoincides {padding: 5px 0;text-align: left}
  /deep/ #adressCoincides .visualCheckBox {border: 1px solid #0a4d3a}
  /deep/ #adressCoincides .visualCheckBox svg {stroke: #0a4d3a}
  #submitWrap{padding: 30px 0;width: 300px;margin: 0 auto}


  .layoutBorder
  {width: 94.5vw;margin: 4vw auto;background: #FFFFFF;box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);border-radius: 8px;}
  .layoutHeader {border-bottom: 2px solid #DFE0E1;padding: 5vw 5vw 4.5vw;}
  .layoutFooter {min-height: 6.6vw;border-top: 2px solid #DFE0E1;padding: 5vw 5vw 4.5vw;position: relative;}
  .layoutFooter.btnIsset{padding: 5vw 5vw 10vw;}
  .layoutBody {background: #F8FAFB;padding: 5vw 5vw 4.5vw;}

  @media screen and (min-width: 760px) {
    .layoutBorder {width: auto;margin: 2vw auto;}
    .layoutHeader {padding: 2.4vw 2.4vw 2.2vw;}
    .layoutFooter {min-height: 1vw;padding: 2.4vw 2.4vw 2.5vw;}
    .layoutFooter.btnIsset {padding: 2.4vw 2.4vw 5vw;}
    .layoutBody {padding: 2.4vw 2.4vw 4.5vw;}
  }

  @media screen and (min-width: 1200px){
    .layoutBorder {margin: 10px auto;max-width: 1100px;}
    .layoutHeader {padding: 15px 20px;}
    .layoutFooter {min-height: 70px;padding: 15px 20px;}
    .layoutFooter.btnIsset{padding: 15px 20px;}
    .layoutBody {padding: 15px 20px;}
  }
</style>
